import logo from "../../../../public/projects/kalpataru-group/logo/logo.png";
import vivant from "../../../../public/projects/kalpataru-group/projects/Vivant.jpg";
import virtus from "../../../../public/projects/kalpataru-group/projects/Virtus.jpg";
import elegante from "../../../../public/projects/kalpataru-group/projects/Elegante.jpg";
import Azuro from "../../../../public/projects/kalpataru-group/projects/Azuro.jpg";
import Advay from "../../../../public/projects/kalpataru-group/projects/Advay.jpg";


// Vivant
import overviewImage_vivant from "../../../../public/projects/kalpataru-group/images/vivant/Overview/1.webp";
import bannerDesktopImage_vivant from "../../../../public/projects/kalpataru-group/images/vivant/Banner/1.webp";
import bannerMobileImage_vivant from "../../../../public/projects/kalpataru-group/images/vivant/Banner/2.webp";
import siteVisitBannerImage_vivant from "../../../../public/projects/kalpataru-group/images/vivant/SiteVisitBanner/1.webp";
import Location_vivant from "../../../../public/projects/kalpataru-group/images/vivant/Location/L1.webp";
import Hightlights_vivant from "../../../../public/projects/kalpataru-group/images/vivant/Highlights/1.webp";
import image1BHK_vivant from "../../../../public/projects/kalpataru-group/images/vivant/floorplan/1.webp";
import image2BHK_vivant from "../../../../public/projects/kalpataru-group/images/vivant/floorplan/2.webp";
import location_vivant from "../../../../public/projects/kalpataru-group/images/vivant/Overview/l.png";
import cal_vivant from "../../../../public/projects/kalpataru-group/images/vivant/Overview/c.png";
import newlaunch_vivant from "../../../../public/projects/kalpataru-group/images/vivant/Overview/n.png";
import g1_vivant from "../../../../public/projects/kalpataru-group/images/vivant/Gallery/1.webp";
import g2_vivant from "../../../../public/projects/kalpataru-group/images/vivant/Gallery/2.webp";
import g3_vivant from "../../../../public/projects/kalpataru-group/images/vivant/Gallery/3.webp";
import g4_vivant from "../../../../public/projects/kalpataru-group/images/vivant/Gallery/4.webp";
import g5_vivant from "../../../../public/projects/kalpataru-group/images/vivant/Gallery/5.webp";


//Azuro
import overviewImage_azuro from "../../../../public/projects/kalpataru-group/images/azuro/Overview/1.webp";
import bannerDesktopImage_azuro from "../../../../public/projects/kalpataru-group/images/azuro/Banner/1.webp";
import bannerMobileImage_azuro from "../../../../public/projects/kalpataru-group/images/azuro/Banner/2.webp";
import siteVisitBannerImage_azuro from "../../../../public/projects/kalpataru-group/images/azuro/SiteVisitBanner/1.webp";
import Location_azuro from "../../../../public/projects/kalpataru-group/images/azuro/Location/L1.webp";
import Hightlights_azuro from "../../../../public/projects/kalpataru-group/images/azuro/Highlights/1.webp";
import image1BHK_azuro from "../../../../public/projects/kalpataru-group/images/azuro/floorplan/1.webp";
import location_azuro from "../../../../public/projects/kalpataru-group/images/azuro/Overview/l.png";
import cal_azuro from "../../../../public/projects/kalpataru-group/images/azuro/Overview/c.png";
import newlaunch_azuro from "../../../../public/projects/kalpataru-group/images/azuro/Overview/n.png";
import g1_azuro from "../../../../public/projects/kalpataru-group/images/azuro/Gallery/1.webp";
import g2_azuro from "../../../../public/projects/kalpataru-group/images/azuro/Gallery/2.webp";
import g3_azuro from "../../../../public/projects/kalpataru-group/images/azuro/Gallery/3.webp";
import g4_azuro from "../../../../public/projects/kalpataru-group/images/azuro/Gallery/4.webp";
import g5_azuro from "../../../../public/projects/kalpataru-group/images/azuro/Gallery/5.webp";


//Advay
import overviewImage_advay from "../../../../public/projects/kalpataru-group/images/advay/Overview/1.webp";
import bannerDesktopImage_advay from "../../../../public/projects/kalpataru-group/images/advay/Banner/1.webp";
import bannerMobileImage_advay from "../../../../public/projects/kalpataru-group/images/advay/Banner/2.webp";
import siteVisitBannerImage_advay from "../../../../public/projects/kalpataru-group/images/advay/SiteVisitBanner/1.webp";
import Location_advay from "../../../../public/projects/kalpataru-group/images/advay/Location/L1.webp";
import Hightlights_advay from "../../../../public/projects/kalpataru-group/images/advay/Highlights/1.webp";
import image1BHK_advay from "../../../../public/projects/kalpataru-group/images/advay/floorplan/1.webp";
import image2BHK_advay from "../../../../public/projects/kalpataru-group/images/advay/floorplan/2.webp";
import image3BHK_advay from "../../../../public/projects/kalpataru-group/images/advay/floorplan/3.webp";
import location_advay from "../../../../public/projects/kalpataru-group/images/advay/Overview/l.png";
import cal_advay from "../../../../public/projects/kalpataru-group/images/advay/Overview/c.png";
import newlaunch_advay from "../../../../public/projects/kalpataru-group/images/advay/Overview/n.png";
import g1_advay from "../../../../public/projects/kalpataru-group/images/advay/Gallery/1.webp";
import g2_advay from "../../../../public/projects/kalpataru-group/images/advay/Gallery/2.webp";
import g3_advay from "../../../../public/projects/kalpataru-group/images/advay/Gallery/3.webp";
import g4_advay from "../../../../public/projects/kalpataru-group/images/advay/Gallery/4.webp";
import g5_advay from "../../../../public/projects/kalpataru-group/images/advay/Gallery/5.webp";

// jadeskyline
import overviewImagejadeskyline from "../../../../public/projects/kalpataru-group/images/jadeskyline/overview/1.webp";
import bannerDesktopImagejadeskyline from "../../../../public/projects/kalpataru-group/images/jadeskyline/banner/1.webp";
import bannerdeveloperjadeskyline from "../../../../public/projects/kalpataru-group/images/jadeskyline/banner/3.webp";
import bannerMobileImagejadeskyline from "../../../../public/projects/kalpataru-group/images/jadeskyline/banner/2.webp";
import Locationjadeskyline from "../../../../public/projects/kalpataru-group/images/jadeskyline/location/1.webp";
import Hightlightsjadeskyline from "../../../../public/projects/kalpataru-group/images/jadeskyline/highlights/1.webp";
import floorplan1jadeskyline from "../../../../public/projects/kalpataru-group/images/jadeskyline/floorplan/1.webp";
import floorplan2jadeskyline from "../../../../public/projects/kalpataru-group/images/jadeskyline/floorplan/2.webp";
import floorplan3jadeskyline from "../../../../public/projects/kalpataru-group/images/jadeskyline/floorplan/3.webp";
import floorplan4jadeskyline from "../../../../public/projects/kalpataru-group/images/jadeskyline/floorplan/4.webp";
import floorplan5jadeskyline from "../../../../public/projects/kalpataru-group/images/jadeskyline/floorplan/5.webp";
import locationiconjadeskyline from "../../../../public/projects/kalpataru-group/images/jadeskyline/overview/l.png";
import caliconjadeskyline from "../../../../public/projects/kalpataru-group/images/jadeskyline/overview/c.png";
import newlaunchiconjadeskyline from "../../../../public/projects/kalpataru-group/images/jadeskyline/overview/n.png";
import gallery1jadeskyline from "../../../../public/projects/kalpataru-group/images/jadeskyline/gallery/1.webp";
import gallery2jadeskyline from "../../../../public/projects/kalpataru-group/images/jadeskyline/gallery/2.webp";
import gallery3jadeskyline from "../../../../public/projects/kalpataru-group/images/jadeskyline/gallery/3.webp";
import gallery4jadeskyline from "../../../../public/projects/kalpataru-group/images/jadeskyline/gallery/4.webp";
import gallery5jadeskyline from "../../../../public/projects/kalpataru-group/images/jadeskyline/gallery/5.webp";



export const developersKalpataru = {
  name: `Kalpataru Properties in Mumbai`,
  properties: [
    {
      name: "Kalpataru  Vivant",
      image: vivant,
      price: "On Request",
      location: "JVLR, Mumbai",
      bed: "1 - 3 BHK",
      state: "Mumbai",
      developer: "Kalpataru Group",
      size: "618 Sq.ft.",
      url: `/kalpataru-vivant-andheri-east-mumbai`,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      },
    },
    {
      name: "Kalpataru  Azuro",
      image: Azuro,
      price: "On Request",
      location: "Mumbai",
      projectlocation: "South Mumbai",
      state: "Mumbai",
      developer: "Kalpataru Group",
      bed: "4 - 5 BHK Apartments",
      size: "On Request",
      url: `/kalpataru-azuro-napeansea-road-mumbai`,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      },
    },
    {
      name: "Kalpataru  Advay",
      image: Advay,
      price: "On Request",
      location: "Mumbai",
      projectlocation: "West Mumbai",
      state: "Mumbai",
      developer: "Kalpataru Group",
      bed: "2, 3, 4 BHK Apartments",
      size: "On Request",
      url: `/kalpataru-advay-borivali-west-mumbai`,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      },
    },
    {
      name: "Kalpataru Jade Skyline",
      image:  bannerdeveloperjadeskyline,
      price: " 1.81 Cr Onwards",
      location: "Baner, Pune",
      projectlocation: "Baner",
      state: "Maharashtra",
      developer: "Kalpataru Group",
      bed: "3 BHK Apartments",
      size: "1189 sq. ft.",
      url: `/kalpataru-jade-skyline`,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      },
    },
  ],
};
export const Headers = {
  logo: logo,
  data: {
    experience: "1969",
  },
  about: `Visionary entrepreneurs, connected by a common vision, teamed up to establish Shubh Developers in 2011. The collective insights, competencies and diverse experiences created a strong synergy of abilities. A code of excellence emerged from this buzzing talent pool. It has concretely shaped our organization over the years, gaining us the trust and confidence of a discerning clientele. We craft landmarks at handpicked locations in the city's upscale neighbourhoods. Our flair for quality and eye for detail are evident at every stage of the building construction lifecycle. Working with a holistic approach, we look at real estate as an engine of socio-economic growth for the nation at large. It is an indicator of progress and a yardstick of development. At Shubh Developers, we are happy to play our part as India makes rapid strides into the future.`,
};

export const projectskalpataru = {
  kalpataruvivant: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImage_vivant,
      bannerMobileImage: bannerMobileImage_vivant,
      textOverlay: "",
      data: {
        title: "Kalpataru Vivant",
        subtitle: "Jogeshwari East, Mumbai",
        starting_price: "1.44 Cr ",
        rerano: "P51800034531",
        payment_plan: "CLP",
        status: "Ready To Move",
      },
    },

    overview: {
      heading: "Kalpataru Vivant, Jogeshwari East – Luxury Homes",
      description: [
        `Kalpataru Vivant is a thoughtfully designed residential project by Kalpataru, located in Jogeshwari East, Mumbai. This project offers a range of well-planned 1 BHK, 2 BHK, and 3 BHK apartments, catering to different space requirements and lifestyle preferences.

The 1 BHK apartments have a carpet area ranging from 437 to 439 sq. ft., making them an ideal choice for individuals or small families. The 2 BHK apartments offer a spacious layout, with sizes varying between 614 and 759 sq. ft., ensuring comfortable living. For those looking for larger homes, the 3 BHK apartments range from 850 to 1076 sq. ft., providing ample space for a growing family.

Situated in Jogeshwari East, Kalpataru Vivant enjoys excellent connectivity to key areas of Mumbai, including business hubs, entertainment zones, educational institutions, and healthcare facilities. The location ensures easy access to major highways, railway stations, and metro services, enhancing the convenience of daily commuting.

Designed to offer a modern and comfortable lifestyle, Kalpataru Vivant features well-planned layouts that maximize space utilization and natural light. The project is developed by Kalpataru, a reputed real estate brand known for its high-quality construction, innovative design, and commitment to excellence.

Kalpataru Vivant is an attractive residential option for homebuyers looking for a well-connected, thoughtfully designed, and spacious home in Jogeshwari East, Mumbai.`,
      ],
      image: overviewImage_vivant,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: location_vivant,
          title: "1.44 Cr ",
          subtitle: "Starting Price",
        },
        {
          iconClass: cal_vivant,
          title: "CLP",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunch_vivant,
          title: "Ready To Move",
          subtitle: "Status",
        },
      ],
    },

    sitevisit: {
      image: siteVisitBannerImage_vivant,
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "1 BHK",
          area: "437 - 439 sq. ft.",
          price: "1.44 - 1.45 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "2 BHK",
          area: "614 - 759 sq. ft.",
          price: "2.09 - 2.58 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "3 BHK",
          area: "850 - 1076 sq. ft.",
          price: "2.37 - 3.66 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "1 BHK",
        area: "437 - 439 sq. ft.",
        price: "1.44 - 1.45 Cr",
        image: image1BHK_vivant,
      },
      {
        type: "2 BHK",
        area: "614 - 759 sq. ft.",
        price: "2.09 - 2.58 Cr",
        image: image2BHK_vivant,
      },
      {
        type: "3 BHK",
        area: "850 - 1076 sq. ft.",
        price: "2.37 - 3.66 Cr",
        image: image2BHK_vivant,
      },
    ],

    highlights: {
      images: Hightlights_vivant,
      tagline: "Highlights",
      features: [
        "Serene Views Of The Cityscape",
        "Close To 3 Upcoming Metro Stations",
        "40+ Lifestyle Amenities For All Generation",
        "Ultra-Spacious 2 & 3 BHK Starting Price",
        "Kalpataru Vivant JVLR has single tower, with 22 floors each and 782 units on offer.",
      ],
    },

    location: {
      image: Location_vivant,
      data: [
        {
          airport: {
            distance_time: "5.4 Km",
            name: "CSMI Airport"
          },
          school: {
            distance_time: "13.7 Km",
            name: "RIMS School"
          },
          railwayormetro: {
            distance_time: "10.8 Km",
            name: "Versova Metro Station"
          },
          hospital: {
            distance_time: "9.4 Km",
            name: " Holy Hospital"
          },
          mall: {
            distance_time: "12.4 Km",
            name: "Infiniti Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: g1_vivant },
        { image: g2_vivant },
        { image: g3_vivant },
        { image: g4_vivant },
        { image: g5_vivant },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Kalpataru Vivant, kindly share more details.",
    },

    faq: [
      {
        question: "Who is the developer of Vivant?",
        answer: `The developer of Vivant is Kalpataru Group.`
      },
      {
        question: "Where is Kalpataru Vivant located?",
        answer: `Kalpataru Vivant is located in Jogeshwari East, Mumbai.`
      },
      {
        question: "What types of apartments are available in Kalpataru Vivant?",
        answer: `Kalpataru Vivant offers 1 BHK, 2 BHK, and 3 BHK apartments.`
      },
      {
        question: "What is the area range of 1 BHK apartments in Kalpataru Vivant?",
        answer: `The area of 1 BHK apartments ranges from 437 to 439 sq. ft.`
      },
      {
        question: "What is the price range of 1 BHK apartments in Kalpataru Vivant?",
        answer: `The price of 1 BHK apartments ranges from ₹1.44 Cr to ₹1.45 Cr.`
      },
      {
        question: "What is the area range of 2 BHK apartments in Kalpataru Vivant?",
        answer: `The area of 2 BHK apartments ranges from 614 to 759 sq. ft.`
      },
      {
        question: "What is the price range of 2 BHK apartments in Kalpataru Vivant?",
        answer: `The price of 2 BHK apartments ranges from ₹2.09 Cr to ₹2.58 Cr.`
      },
      {
        question: "What is the area range of 3 BHK apartments in Kalpataru Vivant?",
        answer: `The area of 3 BHK apartments ranges from 850 to 1076 sq. ft.`
      },
      {
        question: "What is the starting price of apartments in Kalpataru Vivant?",
        answer: `The starting price of apartments in Kalpataru Vivant is ₹1.44 Cr.`
      },
      {
        question: "Which Mumbai locality is Kalpataru Vivant situated in?",
        answer: `Kalpataru Vivant is situated in Jogeshwari East, Mumbai.
`  },
    ],
    similar: {
      properties: [

        {
          name: "Kalpataru - Azuro",
          image: Azuro,
          price: "On Request",
          location: "Mumbai",
          projectlocation: "South Mumbai",
          state: "Mumbai",
          developer: "Kalpataru Group",
          bed: "4 - 5 BHK Apartments",
          size: "On Request",
          url: `/kalpataru-azuro-napeansea-road-mumbai`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
        {
          name: "Kalpataru - Advay",
          image: Advay,
          price: "On Request",
          location: "Mumbai",
          projectlocation: "West Mumbai",
          state: "Mumbai",
          developer: "Kalpataru Group",
          bed: "2, 3, 4 BHK Apartments",
          size: "On Request",
          url: `/kalpataru-advay-borivali-west-mumbai`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },

      ]
    },
    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  kalpataruazuro: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImage_azuro,
      bannerMobileImage: bannerMobileImage_azuro,
      textOverlay: "",
      data: {
        title: "Kalpataru Azuro",
        subtitle: "Napean Sea Road, Malabar Hill, Mumbai",
        starting_price: "On Request",
        rerano: "P51900045295",
        payment_plan: "CLP",
        status: "Under Construction"
      }
    },
    overview: {
      heading: "Kalpataru Azuro – Luxury Residences at Napean Sea Road, Malabar Hill, Mumbai",
      description: [
        "Kalpataru Azuro by Kalpataru is an ultra-luxurious residential project located at Napean Sea Road, Malabar Hill, Mumbai—one of the city's most prestigious and sought-after addresses. This exquisite development redefines elegance, offering opulent living spaces with breathtaking sea views, world-class amenities, and unparalleled exclusivity. Designed for those who appreciate sophistication, Kalpataru Azuro seamlessly blends modern architecture with timeless luxury. The residences feature spacious layouts, premium interiors, and floor-to-ceiling windows that maximize natural light and panoramic Arabian Sea vistas. Every detail, from Italian marble flooring to high-end fittings, exudes grandeur and refinement. The project boasts state-of-the-art amenities, including a rooftop infinity pool, a fully equipped fitness center, a landscaped garden, and 24/7 security for ultimate peace of mind. Residents can enjoy a tranquil lifestyle while being just minutes away from Mumbai’s business districts, premium shopping zones, and fine-dining destinations. Strategically located at Malabar Hill, Kalpataru Azuro offers seamless connectivity to South Mumbai’s prime locations, making it the perfect choice for elite homeowners seeking exclusivity, comfort, and convenience. ",
      ],

      image: overviewImage_azuro,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: location_azuro,
          title: "On Request ",
          subtitle: "Starting Price",
        },
        {
          iconClass: cal_azuro,
          title: "CLP",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunch_azuro,
          title: "Under Construction",
          subtitle: "Status",
        },
      ],
    },

    sitevisit: {
      image: siteVisitBannerImage_azuro,
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "4 BHK",
          area: "On Request",
          price: "On Request",
          eoiAmount: "On Request",
        },
        {
          type: "5 BHK",
          area: "On Request",
          price: "On Request",
          eoiAmount: "On Request",
        },

      ],
    },

    floor_plan: [
      {
        type: "4 BHK",
        area: "On Request",
        price: "On Request",
        image: image1BHK_azuro,
      },
      {
        type: "5 BHK",
        area: "On Request",
        price: "On Request",
        image: image1BHK_azuro,
      },

    ],

    highlights: {
      images: Hightlights_azuro,
      tagline: "Highlights",
      features: [
        "Super exclusive tower with just 14 residences",
        "Ultimate privacy with only one residence per floor",
        "Unhindered, breathtaking Arabian Sea views from the lavish sundeck",
        "Infinity pool with deck and roof top gymnasium",
        "Multi-purpose sky deck and double height lobby",
      ],
    },

    location: {
      image: Location_azuro,
      data: [
        {
          airport: {
            distance_time: "18.6 Km",
            name: "CSMI Airport"
          },
          school: {
            distance_time: "400 m",
            name: "ABI School"
          },
          railwayormetro: {
            distance_time: "2.8 Km",
            name: "Girgaon Metro Station"
          },
          hospital: {
            distance_time: "2.5 Km",
            name: "Jaslok Hospital"
          },
          mall: {
            distance_time: "5.2 Km",
            name: "Phoenix Palladium"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: g1_azuro },
        { image: g2_azuro },
        { image: g3_azuro },
        { image: g4_azuro },
        { image: g5_azuro },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Kalpataru Azuro, kindly share more details.",
    },

    faq: [
      {
        question: "Who is the developer of Azuro Project?",
        answer: `Azuro Project is developed by the Kalpataru Group.`
      },
      {
        question: "Where is Kalpataru Azuro located?",
        answer: `The project is located on Napean Sea Road, Malabar Hill, Mumbai.`
      },
      {
        question: "What types of apartments are available at Kalpataru Azuro?",
        answer: `The project offers luxurious 4 BHK and 5 BHK apartments.`
      },
      {
        question: "What is the area of the apartments in Kalpataru Azuro?",
        answer: `The area details are available on request.`
      },
      {
        question: "What is the starting price of apartments in Kalpataru Azuro?",
        answer: `The starting price is available on request.
` },
      {
        question: "What is the current status of Kalpataru Azuro?",
        answer: `The project is currently under construction.`
      },
      {
        question: "Which is the nearest premium locality to Kalpataru Azuro?",
        answer: `Malabar Hill, one of Mumbai’s most upscale neighborhoods, is nearby.`
      },
      {
        question: "Is Kalpataru Azuro a luxury residential project?",
        answer: `Yes, Kalpataru Azuro is a high-end luxury residential development.`
      },
      {
        question: "What makes the location of Kalpataru Azuro unique?",
        answer: `Napean Sea Road is known for its elite residential ambiance, sea views, and connectivity to South Mumbai.`
      },
      {
        question: "Does Kalpataru Azuro offer sea-facing apartments?",
        answer: `Yes, many apartments are expected to have sea-facing views.`
      },
    ],
    similar: {
      properties: [
        {
          name: "Kalpataru - Vivant",
          image: vivant,
          price: "On Request",
          location: "JVLR, Mumbai",
          bed: "1 - 3 BHK",
          state: "Mumbai",
          developer: "Kalpataru Group",
          size: "618 sq. ft.",
          url: `/kalpataru-vivant-andheri-east-mumbai`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
        {
          name: "Kalpataru - Advay",
          image: Advay,
          price: "On Request",
          location: "Mumbai",
          projectlocation: "West Mumbai",
          state: "Mumbai",
          developer: "Kalpataru Group",
          bed: "2, 3, 4 BHK Apartments",
          size: "On Request",
          url: `/kalpataru-advay-borivali-west-mumbai`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },

      ]
    },
    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },

  },
  kalpataruadvay: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImage_advay,
      bannerMobileImage: bannerMobileImage_advay,
      textOverlay: "",
      data: {
        title: "Kalpataru Advay",
        subtitle: "",
        starting_price: "2.59 Cr",
        rerano: "P51800077381",
        payment_plan: "CLP",
        status: "New Launch"
      }
    },
    overview: {
      heading: "Kalpataru Advay - Premium Homes in Borivali West, Mumbai",
      description: [
        `Kalpataru Advay, a premium residential project by the renowned Kalpataru Group, offers an exceptional lifestyle in the heart of Borivali West, Mumbai. Designed for modern urban living, this project features spacious residences with world-class amenities, ensuring a perfect blend of comfort and convenience.

Strategically located in Borivali West, Kalpataru Advay provides excellent connectivity to key landmarks, business hubs, educational institutions, healthcare facilities, and entertainment zones. With easy access to the Western Express Highway, railway stations, and metro services, residents enjoy seamless travel across Mumbai.

The project boasts thoughtfully designed homes with premium fittings, contemporary architecture, and ample natural light. Residents can indulge in a range of lifestyle amenities, including landscaped gardens, a fully equipped gym, swimming pool, clubhouse, kids’ play area, and multi-purpose sports courts. The secure gated community ensures safety with advanced security systems.

Kalpataru Advay is ideal for homebuyers seeking a luxurious yet serene environment in one of Mumbai’s most sought-after neighborhoods. Its proximity to shopping malls, restaurants, and recreational spots makes it a desirable address for families and professionals alike.
`  ],

      image: overviewImage_advay,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: location_advay,
          title: "2.59 Cr",
          subtitle: "Starting Price",
        },
        {
          iconClass: cal_advay,
          title: "CLP",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunch_advay,
          title: "New Launch",
          subtitle: "Status",
        },
      ],
    },

    sitevisit: {
      image: siteVisitBannerImage_advay,
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "2 BHK",
          area: "781 sq. ft.",
          price: "2.59 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "3 BHK",
          area: "1100 - 1300 sq. ft.",
          price: "3.64 - 4.3 Cr",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK",
          area: "1800 sq. ft.",
          price: "5.95 Cr",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "2 BHK",
        area: "781 sq. ft.",
        price: "2.59 Cr",
        image: image1BHK_advay,
      },
      {
        type: "3 BHK",
        area: "1100 - 1300 sq. ft.",
        price: "3.64 - 4.3 Cr",
        image: image2BHK_advay,
      },
      {
        type: "4 BHK",
        area: "1800 sq. ft.",
        price: "5.95 Cr",
        image: image3BHK_advay,
      },
    ],

    highlights: {
      images: Hightlights_advay,
      tagline: "Highlights",
      features: [
        "50+ premium lifestyle amenities",
        "Spacious apartments with large deck",
        "Miyawaki plantations",
        "Machan seating in a tree bosque",
        "Butterfly and aromatic gardens",
      ],
    },

    location: {
      image: Location_advay,
      data: [
        {
          airport: {
            distance_time: "20.4 Km",
            name: "CSMI Airport"
          },
          school: {
            distance_time: "550 m",
            name: "Don Bosco School"
          },
          railwayormetro: {
            distance_time: "1.8 Km",
            name: "Borivali Metro Station"
          },
          hospital: {
            distance_time: "1.8 Km",
            name: " Lotus Hospital"
          },
          mall: {
            distance_time: "700 m",
            name: "The Zone Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: g1_advay },
        { image: g2_advay },
        { image: g3_advay },
        { image: g4_advay },
        { image: g5_advay },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Kalpataru Advay, kindly share more details.",
    },

    faq: [
      {
        question: "What is the name of the project?",
        answer: `The project is called Kalpataru Advay.`
      },
      {
        question: "Who is the developer of Kalpataru Advay?",
        answer: `The developer is Kalpataru Group.
` },
      {
        question: "Where is Kalpataru Advay located?",
        answer: `It is located in Borivali West, Mumbai.`
      },
      {
        question: "What types of apartments are available in Kalpataru Advay?",
        answer: `The project offers 2 BHK, 3 BHK, and 4 BHK apartments.
`  },
      {
        question: "What is the area and price of a 2 BHK in Kalpataru Advay?",
        answer: `2 BHK apartment has an area of 781 sq. ft. and is priced at ₹2.59 Cr.`
      },
      {
        question: "What is the size range of a 3 BHK in this project?",
        answer: `3 BHK apartment ranges from 1100 to 1300 sq. ft.`
      },
      {
        question: "What is the price range of a 3 BHK unit?",
        answer: `The price of a 3 BHK ranges between ₹3.64 Cr to ₹4.3 Cr.
`  },
      {
        question: "What is the size and price of a 4 BHK apartment?",
        answer: `4 BHK has an area of 1800 sq. ft. and is priced at ₹5.95 Cr.`
      },
      {
        question: "What is the starting price of apartments in Kalpataru Advay?",
        answer: `The starting price is ₹2.59 Cr.`
      },
      {
        question: "What is the current status of the project?",
        answer: `The project is a New Launch.`
      },
    ],
    similar: {
      properties: [
        {
          name: "Kalpataru - Vivant",
          image: vivant,
          price: "On Request",
          location: "JVLR, Mumbai",
          bed: "1 - 3 BHK",
          state: "Mumbai",
          developer: "Kalpataru Group",
          size: "618 Sq.ft.",
          url: `/kalpataru-vivant-andheri-east-mumbai`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
        {
          name: "Kalpataru - Azuro",
          image: Azuro,
          price: "On Request",
          location: "Mumbai",
          projectlocation: "South Mumbai",
          state: "Mumbai",
          developer: "Kalpataru Group",
          bed: "4 - 5 BHK Apartments",
          size: "On Request",
          url: `/kalpataru-azuro-napeansea-road-mumbai`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
      ]
    },
    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },

  },
  jadeskyline: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImagejadeskyline,
      bannerMobileImage: bannerMobileImagejadeskyline,
      textOverlay: "",
      data: {
        title: "Kalpataru Jade Skyline",
        subtitle: "Baner, Pune",
        starting_price: "₹ 1.81 Cr Onwards",
        payment_plan: "Under Construction",
        rerano: "P52100033791",
        status: "Under Construction",
      },
    },
    overview: {
      heading: "Kalpataru Jade Skyline - Urban Sophistication Meets Natural Serenity",
      description: [
        "Kalpataru Jade Skyline in Baner, Pune, is a premium residential project offering a perfect blend of modern living and natural tranquility. Situated near the Baner hills and overlooking a 500+ acre Biodiversity Park, the project provides residents with a serene environment amidst the urban landscape.",
        "The development features spacious 2 and 3 BHK apartments, with carpet areas ranging from 858 to 1,189 sq. ft. Each unit is thoughtfully designed with magna interiors, including split inverter ACs in all bedrooms, false ceilings, modular kitchens, glass partitions, shower panels, and boilers in bathrooms.",
      ],
      keywordLinks: {},
      image: overviewImagejadeskyline,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconjadeskyline,
          title: "₹ 1.81 Cr Onwards",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconjadeskyline,
          title: "CLP",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconjadeskyline,
          title: "Under Construction",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK",
          area: "1189 sq. ft.",
          price: "₹ 1.8 Cr Onwards",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK",
        area: "1189 sq. ft.",
        price: "₹ 1.8 Cr Onwards",
        image: floorplan1jadeskyline,
      },
    ],

    highlights: {
      images: Hightlightsjadeskyline,
      tagline: "Highlights",
      features: [
        "Premium residential project in Baner's trendiest locale",
        "Located near Baner hills, overlooking 500+ acres of Biodiversity Park",
        "Thoughtfully designed homes with magna-interiors",
        "Two private decks with hill views",
        "Luxury of choosing a done-up kitchen",
        "Spanning approximately 2.5 acres with 5 towers",
        "Configuration of 3B+G+4P+21 floors",
        "Total of 299 units",
      ],
    },

    location: {
      image: Locationjadeskyline,
      data: [
        {
          airport: {
            distance_time: "18.2 km",
            name: "Pune Airport",
          },
          school: {
            distance_time: "3 Km",
            name: "The Orchid School",
          },
          railwayormetro: {
            distance_time: "12.5 Km",
            name: "Pune Station",
          },
          hospital: {
            distance_time: "2 Km",
            name: "Jupiter Hospital",
          },
          mall: {
            distance_time: "3 Km",
            name: "Westend Mall",
          },
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1jadeskyline },
        { image: gallery2jadeskyline },
        { image: gallery3jadeskyline },
        { image: gallery4jadeskyline },
        { image: gallery5jadeskyline },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "",
      welcomeMessage:
        "Hi! I'm interested in Kalpataru Jade Skyline, kindly share more details.",
    },

    faq: [
      {
        question: "What are the apartment configurations available?",
        answer: "Kalpataru Jade Skyline offers 2 BHK and 3 BHK apartments.",
      },
      {
        question: "What is the possession date for the project?",
        answer: "The possession of Kalpataru Jade Skyline is expected by December 2026.",
      },
      {
        question: "What amenities are provided in Kalpataru Jade Skyline?",
        answer: "The project offers amenities like a clubhouse, swimming pool, gymnasium, landscaped gardens, kids' play area, senior citizen area, yoga and meditation zones, indoor games, and a party lawn.",
      },
      {
        question: "Is the project RERA registered?",
        answer: "Yes, Kalpataru Jade Skyline is RERA registered with the ID P52100033791.",
      },
      {
        question: "Who is the developer of Kalpataru Jade Skyline?",
        answer: "The project is developed by Kalpataru Group.",
      },
      {
        question: "What is the total area of the project?",
        answer: "Kalpataru Jade Skyline spans approximately 2.5 acres of land.",
      },
      {
        question: "How many towers and floors does the project have?",
        answer: "The project comprises five towers with configurations of 3B+G+4P+21 floors.",
      },
      {
        question: "What are the unique features of the apartments?",
        answer: "Each apartment includes split inverter ACs in all bedrooms, false ceilings, modular kitchens, glass partitions, shower panels, and boilers in bathrooms.",
      },
      {
        question: "What are the nearby landmarks and facilities?",
        answer: "The project is close to educational institutions like The Orchid School, healthcare facilities such as Jupiter Hospital, and commercial centers like Westend Mall.",
      },
      {
        question: "Where is Kalpataru Jade Skyline located?",
        answer: "The project is situated on Pan Card Club Road in Baner, Pune.",
      },
    ],

    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry",
      to_email: "leads@gurugram-property.com",
    },
  },


};